import React from 'react';
import { Container } from '@material-ui/core';
import EmptyState from '../components/common/EmptyState';

const NotFoundPage = () => (
  <Container maxWidth="sm" style={{ marginTop: '4rem' }}>
    <EmptyState
      title="404 - Page not found"
      description="The page you requested does not exist or has been moved."
      actionLabel="Go Home"
      actionTo="/"
    />
  </Container>
);

export default NotFoundPage;
